import React from 'react';
import Dispatcher from '../../dispatcher';
var HeaderContainer = require('../layouts/header-container');
var Menu = require('../ui_elements/menu').Menu;
var MenuMixin = require('../ui_elements/menu').MenuMixin;
var MainMenu = require('../ui_elements/main-menu').MainMenu;

import SignInContainer       from './signin';
import ForgotContainer       from './forgot';
import ActivationContainer   from './activation';
import RegistrationContainer from './registration';
import ForceUpdateContainer  from './force-update-container';
import SSO                   from './sso';
import TermsContainer        from './terms-container';
import { VstLocales }        from 'vstui';
import CookieCat          from '../accept-cookies/banner';

// Renders the User View (all general user pages)
class UserPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      hasBanner: !Fraction.Helpers.Users.getUserData('allow-cookies')
    };

    // MenuMixin methods
    this._toggleMenu = MenuMixin._toggleMenu.bind(this);
    this._showMenu = MenuMixin._showMenu.bind(this);
    this._removeMenu = MenuMixin._removeMenu.bind(this);
    this._redrawMenu = MenuMixin._redrawMenu.bind(this);

    // Bind callback methods
    this._redraw = this._redraw.bind(this);
    this._updateCookies = this._updateCookies.bind(this);
    this._updateLocale = this._updateLocale.bind(this);
    this._renderAccountGraphic = this._renderAccountGraphic.bind(this);
    this._isValidEmail = this._isValidEmail.bind(this);
    this._isValidPassword = this._isValidPassword.bind(this);
    this._renderPage = this._renderPage.bind(this);
  }

  componentDidMount(){
    // TODO shouldn't just be signin, should update/change
    $('body').addClass('signin-body');
    window.addEventListener('resize', this._redraw);
    Fraction.Helpers.bindLinks();
    Fraction.Helpers.modalRedraw = this._redraw;
    Fraction.Helpers.passwordInputShim();
    Dispatcher.bind(Dispatcher.SAVE_USER_DATA, this._updateCookies);
    Dispatcher.bind(Dispatcher.LOCALE_CHANGE, this._redraw);
  }

  // redraw this container!
  _redraw(){
    setTimeout(() => this.forceUpdate(), 0);
  }

  _updateCookies() {
    this.setState({ hasBanner: !Fraction.Helpers.Users.getUserData('allow-cookies') });
  }

  componentWillUnmount(){
    // TODO shouldn't just be signin, should update/change
    $('body').removeClass('signin-body');

    window.removeEventListener('resize', this._redraw);
    Dispatcher.unbind(Dispatcher.LOCALE_CHANGE, this._redraw);
  }

  componentDidUpdate(){
    $("#login-return").val(document.location.protocol+"//"+document.location.host);
  }

  // TODO :: What's this do?
  _updatePowerByClass(powerByPositionSt) {
    this.setState({
      powerByPositionSt: powerByPositionSt
    });
  }

  _getSvgAsObject(data) {
    return (
      <object type="image/svg+xml"
              data={data}
              className="logo"
              aria-hidden={true}
              tabIndex={-1}>
        {i18n.t('signin.signin-graphic')}
      </object>
    );
  }

  _renderAccountGraphic(imageName){
    imageName = imageName || "signin";
    let image;
    if (Fraction.Brand.Graphics[imageName]) {
      if (Fraction.Brand.Graphics[imageName].indexOf(".svg")===-1){
        image = <img src={Fraction.Brand.Graphics[imageName]} alt="" />;
      } else {
        image = this._getSvgAsObject(Fraction.Brand.Graphics[imageName]);
      }
    } else {
      if (!Fraction.Brand.Graphics.watkins || (Fraction.Helpers.isSmallScreen() && imageName !== "signin")){
        image = <span aria-hidden="true"></span>;
      } else {
        let watkinsPath;
        switch (imageName) {
          case "signin":
            watkinsPath = "/img/watkins_welcome.svg";
          break;
          case "register":
          case "forgot":
            watkinsPath = "/img/watkins_register_scribbles.svg";
          break;
        }
        image = this._getSvgAsObject(watkinsPath);
        image = Fraction.Helpers.holidayWatkins() || image;
      }
    }
    return (
      <span>
        <div className="account-graphic">
          {image}
        </div>
        <div className="small-account-graphic">
          {!Fraction.Brand.Graphics[imageName] > 0 && image}
        </div>
      </span>
    );
  }

  _isValidEmail(email){
    // TODO take the jiffy regex and put it here
    var validEmail = /^([^@\s]+)@((?:[-_a-z0-9]+\.)+[a-z]{2,})$/;
    return validEmail.test(email);
  }

  _updateLocale(locale){
    Fraction.Helpers.updateLocaleOnLogin(locale);
    Fraction.Helpers.changeLocale(locale, () => {});
  }

  _isValidPassword(email){

  }

  _renderPage(){
    const methods = {
      renderAccountGraphic : this._renderAccountGraphic,
      isValidEmail         : this._isValidEmail,
      isValidPassword      : this._isValidPassword
    };
    switch (this.props.page){
      case "signin":
        return <SignInContainer {...methods} {...this.props} />;
      case "forgot":
        return <ForgotContainer {...methods} {...this.props} />;
      case "activation":
        return <ActivationContainer {...methods} {...this.props} />;
      case "registration":
        return <RegistrationContainer {...methods} {...this.props} />;
      case "sso":
        return <SSO {...methods} {...this.props} />;
      case "update-password":
        return <ForceUpdateContainer {...methods} {...this.props} />;
      case "terms":
        return <TermsContainer {...methods} {...this.props} />;
    }
  }

  render() {
    let containerClass = "account-container";
    let containerStyle = {};
    if (Fraction.Brand.Graphics.background) {
      containerClass += " cover-background";
      containerStyle = {
        "background-image": "url('" + Fraction.Brand.Graphics.background + "')",
        height: "100%"
      };
    }
    if (this.state.hasBanner) { containerClass += ' accept-cookies-banner'; }
    if (Fraction.Helpers.isSmallScreen()) { containerClass += ' mobile'; }

    // TODO :: disableLink might be reg and sso specific
    // TODO :: powerByPositionSt might be signin specific
    // TODO :: updatePowerByClass might be signin specific

    // TODO :: This main menu may be signin specific
    return (
      <div className="user-page__container">
       <CookieCat />
       <div className={containerClass} style={containerStyle}>
          {this._renderPage()}
        </div>
        <footer className="user-page__footer">
          {Fraction.Brand.Menu.poweredBy &&
            <div className="menu-logo">{window.toHTML(i18n.t('base.poweredBy', {url: "/img/vitalsource_color.svg"}))}</div>
          }
          <VstLocales
            className="user-page__locale-menu-button"
            selected={i18n.getCurrentLocale()}
            onChange={this._updateLocale}
            customX={25}
            customY={-415}
          />
        </footer>
      </div>
    );
  }

}

module.exports = UserPage;
